/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';

const CustomPriceComponent = React.memo((props) => {
  const { value, data } = props;
  return (
    <span
      className={data?.isBottomRow ? 'semiBoldText' : ''}
      style={{
        color: value !== null && parseFloat(value) < 0 ? 'red' : '#000',
        fontWeight: value !== null && parseFloat(value) < 0 ? 600 : 400,
      }}
    >
      {value
        ? parseFloat(value) < 0
          ? `($ ${(parseFloat(value) * -1)?.toFixed(2)})`
          : `$ ${parseFloat(value)?.toFixed(2)}`
        : '$ 0.00'}
    </span>
  );
});

export default CustomPriceComponent;
